import { siteName } from "@/mocks/manga";

const footerLinks = [
  { label: "故事简介", href: "#story" },
  { label: "角色介绍", href: "#characters" },
  { label: "关系图谱", href: "#relationship" },
  { label: "CP感情线", href: "#romance" },
  { label: "热门内容", href: "#articles" },
  { label: "常见问题", href: "#faq" },
];

export default function Footer() {
  return (
    <footer className="bg-background-200 py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <a href="#home" className="flex items-center gap-2 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-white">
                <i className="ri-heart-3-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                恋爱辅助器<span className="text-primary-600">漫画站</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-7 text-foreground-700">
              专注整理《恋爱辅助器》漫画角色、男主女主人物介绍、角色关系图谱与CP感情线的爱好者百科站。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-950">快速导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {footerLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-950">关注我们</h3>
            <p className="mt-4 text-sm leading-7 text-foreground-700">
              跟进最新的角色与CP动态，欢迎通过下方渠道找到我们。
            </p>
            <div className="mt-4 flex gap-2">
              {["ri-weibo-line", "ri-bilibili-line", "ri-twitter-x-line", "ri-mail-line"].map((ic) => (
                <a
                  key={ic}
                  href="#contact"
                  aria-label="社交平台链接"
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-white"
                >
                  <i className={ic} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © 2026 {siteName} · 内容为爱好者整理，版权归原作者所有
          </p>
          <p className="flex items-center gap-1.5 text-xs text-foreground-600">
            <i className="ri-heart-2-line text-primary-500" aria-hidden="true"></i>
            为每一个喜欢的角色与CP而生
          </p>
        </div>
      </div>
    </footer>
  );
}